import { gsap } from 'gsap';
import { PixiPlugin } from 'gsap/PixiPlugin';
import pixi from './pixi';

PixiPlugin.registerPIXI(pixi);
gsap.registerPlugin(PixiPlugin);

export default gsap;
